import { Link } from "@tanstack/react-router";

type Props = {
  pillar: string;
  discipline: string;
  description: string;
  href?: string;
  cta?: string;
};

export function PillarCard({ pillar, discipline, description, href, cta }: Props) {
  const ctaLabel = cta ?? "↗";
  const inner = (
    <div className="group relative flex h-full flex-col gap-5 rounded-lg border border-rule bg-white p-8 transition-all hover:-translate-y-0.5 hover:border-cyan hover:shadow-[0_12px_40px_-20px_oklch(0.6_0.11_225/0.4)]">
      <div className="font-mono text-xs uppercase tracking-[0.18em] text-cyan-deep">
        {pillar}
      </div>
      <div className="font-display text-2xl text-ink md:text-3xl">{discipline}</div>
      <p className="text-ink-3 leading-relaxed">{description}</p>
      {href && (
        <span className="mt-auto pt-4 font-mono text-xs uppercase tracking-wider text-ink-2 transition-colors group-hover:text-cyan-deep">
          {ctaLabel}
        </span>
      )}
    </div>
  );
  return href ? <Link to={href} className="block h-full">{inner}</Link> : inner;
}
